import { createContext } from "react";

interface HoopsViewerContextType {
  fileVersionId: string;
  fileVersionData?: any;
  viewerImpl: {
    hwv: any;
    loadMarkups?: any;
    activateOperator?: any;
    isLeafNode?: any;
    deleteModel?: any;
    loadModels?: any;
    setMarkupViewEditMode?: any;
    cuttingPlaneToggle?: any;
    resetViewer?: any;
    _operatorManager?: any;
    _cuttingPlaneController?: any;
    cuttingPlaneGeomVisibilityToggle?: any;
    cuttingPlaneModeToggle?: any;
    addPlaneHandles?: any;
    removePlaneHandles?: any;
    sectionBoxGeometryToggle?: any;
    _clippingBox?: any;
    sectionBoxScaleHandleToggle?: any;
    sectionBoxHandlesToggle?: any;
    sectionBoxToggle?: any;
    resetCuttingPlane?: any;
    _drawingManimulator?: any;
    unsetCallbacks?: any;
  } | null;
  isModelStructureReady: boolean;
  isSettingsApplied: boolean;
  socketDisconnected: boolean;
  HoopsModalStatus: any;
  selectedIssues: any;
  currentViewIssueId: string | null | undefined;
  transmittalVersionId: string | null | undefined;
  portalUnits?: {
    linearUnits: any[];
    areaUnits: any[];
    volumeUnits: any[];
  };
  handleClick?: any;
  handleKeyDown?: any;
  quantityTakeoffToolbar?: any;
}

export const HoopsViewerContext = createContext<HoopsViewerContextType>({
  fileVersionId: "",
  viewerImpl: null,
  isModelStructureReady: false,
  isSettingsApplied: false,
  socketDisconnected: false,
  HoopsModalStatus: {},
  selectedIssues: {},
  currentViewIssueId: undefined,
  transmittalVersionId: undefined,
  portalUnits: undefined,
});
